
/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  PendingRecommendation,
} from '../models';
import {
    PendingRecommendationFromJSON,
    PendingRecommendationToJSON,
} from '../models';

export interface RemovePendingRecommendationRequest {
    recommendationId: string;
}

export interface SearchPendingRecommendationsByAccountIdRequest {
    accountId: string;
}

/**
 * 
 */
export class PendingRecommendationAdminApi extends runtime.BaseAPI {

    /**
     * Remove a pending recommendation
          */
    async removePendingRecommendationRaw(requestParameters: RemovePendingRecommendationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['recommendationId'] == null) {
            throw new runtime.RequiredError(
                'recommendationId',
                'Required parameter "recommendationId" was null or undefined when calling removePendingRecommendation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/profile/api/admin/pending-recommendations/{recommendationId}`.replace(`{${"recommendationId"}}`, encodeURIComponent(String(requestParameters['recommendationId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Remove a pending recommendation
          */
    async removePendingRecommendation(requestParameters: RemovePendingRecommendationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.removePendingRecommendationRaw(requestParameters, initOverrides);
    }

    /**
     * List the pending recommendations asked by a freelancer
          */
    async searchPendingRecommendationsByAccountIdRaw(requestParameters: SearchPendingRecommendationsByAccountIdRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<PendingRecommendation>>> {
        if (requestParameters['accountId'] == null) {
            throw new runtime.RequiredError(
                'accountId',
                'Required parameter "accountId" was null or undefined when calling searchPendingRecommendationsByAccountId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['accountId'] != null) {
            queryParameters['accountId'] = requestParameters['accountId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<PendingRecommendation>>({
            path: `/profile/api/admin/pending-recommendations`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(PendingRecommendationFromJSON);
        return response;
    }

    /**
     * List the pending recommendations asked by a freelancer
          */
    async searchPendingRecommendationsByAccountId(requestParameters: SearchPendingRecommendationsByAccountIdRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<PendingRecommendation>> {
        const response = await this.searchPendingRecommendationsByAccountIdRaw(requestParameters, initOverrides);
        return response._data;
    }

}
